// @flow
import type { Url, Resource } from './Resource';
import type { TransformConfig } from './Transform';
import { mapConfigToTransform } from './Transform';
import {
  createUploadedImageResource,
  createYoutubeVideoResource,
  createUploadedVideoResource,
  createProductImageResource,
  YoutubeRegex,
} from './Resource';

export type UrlSet = {
  raw: Url,
  thumbnail: Url,
  small: Url,
  medium: Url,
  large: Url,
  full: Url,
};

function url(res: Resource, config: ?TransformConfig = null): Url {
  const {
    accessType,
    resourceType,
    publicId = 'portal-no-product-image_ttlfpi.svg',
  } = res;
  const basePathName = `//res.cloudinary.com/powerreviews/${resourceType}/${accessType}`;

  if (!config) {
    return `${basePathName}/${publicId}`;
  }

  const params = mapConfigToTransform(config);
  return `${basePathName}/${params}/${publicId}`;
}

function urlSet(res: Resource, config: ?TransformConfig = null): UrlSet {
  const defaultOptions = {
    quality: 'auto',
    format: 'auto',
    default_image: 'portal-no-product-image_ttlfpi.svg',
  };
  const { accessType } = res;

  return {
    raw:
      accessType === 'youtube'
        ? '//www.youtube.com/embed/' + res.publicId // ? '//www.youtube.com/watch?v=' + res.publicId
        : url(res),
    thumbnail: url(res, {
      ...defaultOptions,
      width: 100,
      height: 100,
      crop: 'thumb',
    }),
    small: url(res, {
      ...defaultOptions,
      width: 175,
      height: 175,
      crop: 'lpad',
    }),
    medium: url(res, {
      ...defaultOptions,
      width: 300,
      height: 300,
      crop: 'lpad',
    }),
    large: url(res, {
      ...defaultOptions,
      width: 'auto',
      height: 500,
    }),
    full: url(res, {
      ...defaultOptions,
      width: 'auto',
      height: 768,
    }),
  };
}

export function isYoutubeVideo(url: Url) {
  return YoutubeRegex.test(url);
}

export function getYoutubeVideoID(url: Url) {
  if (!isYoutubeVideo(url)) return null;

  return url.split(YoutubeRegex).pop();
}

export default {
  url,
  urlSet,
  libraryUrlSet(url: Url) {
    const res = createUploadedImageResource(url);
    return urlSet(res);
  },
  fetchUrlSet(url: Url) {
    const res = createProductImageResource(
      url ? url : 'http://httpstat.us/404'
    );
    return urlSet(res);
  },
  libraryVideoUrlSet(url: Url) {
    const res = createUploadedVideoResource(url);
    return urlSet(res);
  },
  youtubeUrlSet(url: Url) {
    const res = createYoutubeVideoResource(url);
    return urlSet(res);
  },
  isYoutubeVideo,
  getYoutubeVideoID,
};



// WEBPACK FOOTER //
// ./src/lib/pwr-cloudinary/PwrCloudinary.js